import { FormItem } from "@/cs-ts-bridge/ts/form-item";
import { BaseElementDef, BaseElementDefBase } from "./BaseElementDef";
import { FormDefinitionItem } from "./__DefinitionDataInterface";
import { DisplayStampedPdfSettings } from "@cs-ts/display-stamped-pdf-settings";
import { CalculationContext } from "./__CalculationContextInterface";

export default class DisplayStampedPdfDef extends BaseElementDef<DisplayStampedPdfSettings, FormDefinitionItem<DisplayStampedPdfSettings>, FormItem> {
    declare isCustomViewType: true;

    constructor(parentElement: BaseElementDefBase | null, elementData: FormItem, definitionData: FormDefinitionItem<DisplayStampedPdfSettings>, calculationContext: CalculationContext) {
        super(parentElement, elementData, definitionData, calculationContext);
        this.isCustomViewType = true;
    }

    visible() {
        const showByDefault = this.definition.settings.showByDefault;
        if (showByDefault == 0) {
            return Promise.resolve(true);
        } else if (showByDefault == 1) {
            return Promise.resolve(false);
        } else {
            return this.resolveCalculationPromiseBool(this.definition.settings.showByDefaultCalculatedId!);
        }
    }

    viewTypes() {
        return [this.definition.settings.label];
    }
}
